export const CHECKOUT_STEPS = [
  'Pup Quiz',
  'Recommended Plan',
  'Extras',
  'Secure Checkout',
];
